import styled from "styled-components";

export const SeparateLine = styled.div`
    margin: 36px auto;
    width: 100%;
    background-color: #c4c4c4;
    height: 1px;
`;
export const ButtonRow = styled.div`
    flex: 1;
    display: flex;
    justify-content: flex-end;
`;
export const TagsContainer = styled.div`
    margin-left: 2rem;
`;
export const Tags = styled.div`
    border-radius: 6px;
    background-color: #f6b818;
    color: #fff;
    width: fit-content;
    padding: 6px 10px;
    font-size: 16px;
    font-weight: 400;
`;
export const ProjectInfo = styled.div`
    padding: 28px 36px;
    background-color: white;
    border-radius: 20px;
    margin: 18px 0;
    h2 {
        font-size: 20px;
        font-weight: 700;
        margin-bottom: 17px;
    }
`;
export const ProjectCondition = styled.div`
    padding: 41px 28px;
    background-color: white;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    h3 {
        font-size: 18px;
        font-weight: 700;
        margin-bottom: 24px;
        color: #198aa5;
    }
`;
export const WorkingConditionSteps = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    .active {
        color: #0061a6;
        background-color: rgba(0, 119, 204, 0.2);
    }
`;
export const ConditionSteps = styled.div`
    display: flex;
    background-color: #fff;
    border-top-left-radius: 22px;
    border-top-right-radius: 22px;
    padding: 15px 19px;
    font-size: 15px;
    font-weight: 700;
    margin-right: 5px;
    cursor: pointer;
`;
export const MileageUnit = styled.div`
    position: absolute;
    top: 55%;
    right: 15%;
    font-size: 15px;
    font-weight: bold;
    .isEditableStyle {
        right: 75%;
    }
`;
export const MileageInput = styled.div`
    position: relative;
    width: 100%;
    input {
        // margin-top: 8px;
    }
`;

export const DataView = styled.div`
    font-size: 16px;
    color: #171717;
    font-weight: 400;
    line-height: 2rem;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    span {
        margin-right: 2rem;
        display: flex;
        h4 {
            margin-right: 1rem;
        }
    }
    span.error {
        color: red;
        margin-right: 2rem;
        display: flex;
        h4 {
            margin-right: 1rem;
        }
    }
`;
export const ActionsContainer = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 2rem;
    justify-content: space-between;
`;
export const PageTitle = styled.div`
    display: flex;
    font-size: 24px;
    font-weight: 700;
    text-transform: capitalize;
    align-items: center;
`;
export const StyledAction = styled.div`
    display: flex;
    justify-content: flex-end;
`;
export const DeactivateReasonContainer = styled.div`
    background: #fffbeb;
    border-radius: 6px;
    display: flex;
    flex-direction: row;
    padding: 16px;
    justify-content: flex-start;
    align-items: flex-start;
    margin-bottom: 32px;

    svg {
        margin: 0 14px 0 0;
        color: #fbbf24;
    }
`;

export const ObjectionContainer = styled.div`
    display: flex;
    flex-direction: row;
`;
export const ProjectFinancialLegalContainer = styled.div`
    display: flex;
    flex-direction: row;
    padding: 0;
`;

export const ErrorsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    margin-top: 5px;
`;
export const ErrorMessage = styled.div`
    width: 100%;
    background-color: #f8e9e9;
    padding: 16px;
    color: #bd271e;
    font-weight: 500;
    font-size: 16px;
    display: flex;
    gap: 9px;
    align-items: center;

    svg {
        width: 14px;
        height: 14px;
        color: #bd271e;
    }
`;

export const ConfirmModalContent = styled.p`
    font-weight: 400;
    font-size: 20px;
    color: black;
    span {
        font-weight: 600;
    }
`;
